"use strict";

exports.__esModule = true;
exports.MetricDataTable = MetricDataTable;
var _react = _interopRequireWildcard(require("react"));
var _CalendarContext = require("../../Calendar/CalendarContext");
var _common = require("../../ConfigurableLayout/common");
var _DataTable = require("../../Core/DataTable/DataTable");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _useSelectionContextRowSelection = require("../../Core/DataTable/useSelectionContextRowSelection");
var _SelectionContext = require("../../Core/SelectionContext");
var _Translator = require("../../Core/Translator");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _ReportingPeriodContext = require("../../Time/ReportingPeriod/ReportingPeriodContext");
var _TimeContext = require("../../Time/TimeContext");
var _helpers = require("../DataTable/helpers");
var _getOnRowClick = require("./getOnRowClick");
var _pivotByTime = require("./pivotByTime");
var _PlantStateActivities = require("../../PlantStateActivities");
var _formatMetricTableData = require("./formatMetricTableData");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function MetricDataTable(props) {
  var _React$useContext = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext),
    wrappingInterval = _React$useContext.interval;
  var _React$useContext2 = _react["default"].useContext(_SelectionContext.SelectionContext),
    setSelection = _React$useContext2.setSelection;
  var _React$useContext3 = _react["default"].useContext(_CalendarContext.CalendarContext),
    calendar = _React$useContext3.calendar;
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var translator = _react["default"].useContext(_Translator.TranslatorContext);
  var query = props.query,
    loading = props.loading,
    data = props.data,
    configuration = props.configuration,
    height = props.height,
    width = props.width,
    dataRange = props.dataRange,
    path = props.path,
    columns = props.columns,
    shouldPivot = props.pivotByTime,
    showAverageColumn = props.showAverageColumn,
    showTotalColumn = props.showTotalColumn,
    showChangeColumn = props.showChangeColumn,
    showHeatMap = props.showHeatMap,
    showTrendColumn = props.showTrendColumn,
    showTargets = props.showTargets,
    noDataText = props.noDataText,
    reload = props.reload,
    additionalToolbarSelectors = props.additionalToolbarSelectors,
    selectedMetric = props.selectedMetric;
  var defaultPageSize = (0, _helpers.nearestIndexInPageSizeList)([5, 10, 25, 100], (0, _helpers.getDefaultPageSize)(configuration, height) < 0 ? 0 : (0, _helpers.getDefaultPageSize)(configuration, height));
  var _useState = (0, _react.useState)({
      page: 0,
      pageSize: defaultPageSize
    }),
    pagination = _useState[0],
    setPagination = _useState[1];
  var translate = translator.translate;
  var componentPath = (0, _common.getComponentPath)(path);
  var _useSelectionContextR = (0, _useSelectionContextRowSelection.useSelectionContextRowSelection)({
      componentPath: componentPath
    }),
    selectedRowIndex = _useSelectionContextR.selectedRowIndex,
    setSelectedRowIndex = _useSelectionContextR.setSelectedRowIndex,
    resetSelectedRowIndex = _useSelectionContextR.resetSelectedRowIndex;
  var formattedColumns = (0, _formatColumns.formatColumns)(columns, data, {
    translate: translate,
    time: time,
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  if (shouldPivot) {
    // TODO: cleaner abstractions to accommodate workday and hour in same aggregate by section.
    var selectTimeformat = function selectTimeformat() {
      if (query && query.bins.find(function (x) {
        return x.binName === "by_workday";
      })) {
        return query.bins.find(function (x) {
          return x.binName === "by_workday";
        }).options.calendar_interval;
      } else if (query && query.bins.find(function (x) {
        return x.binName === "by_hour";
      }) && query.bins.find(function (x) {
        return x.aggType === "date_histogram";
      })) {
        return "hour-day";
      } else if (query && query.bins.find(function (x) {
        return x.binName === "by_hour";
      })) {
        return "hour";
      }
      return "day";
    };
    var getTimeAggregateField = function getTimeAggregateField() {
      return query && query.bins.find(function (x) {
        return x.binName === "by_hour";
      }) ? "hour" : "workday";
    };
    formattedColumns = (0, _formatColumns.formatColumns)((0, _pivotByTime.getTimeAggregateColumns)({
      timeAggregateField: getTimeAggregateField(),
      metrics: query ? query.metrics : [],
      columns: columns,
      data: data,
      showAverageColumn: showAverageColumn,
      showTotalColumn: showTotalColumn,
      showChangeColumn: showChangeColumn,
      showHeatMap: showHeatMap,
      showTrendColumn: showTrendColumn,
      showTargets: showTargets,
      timeAggregateFieldGrouping: selectTimeformat(),
      time: time
    }), data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities
    });
  }
  var onRowClick = (0, _getOnRowClick.getOnRowClick)({
    selectedRowIndex: selectedRowIndex,
    setSelectedRowIndex: setSelectedRowIndex,
    resetSelectedRowIndex: resetSelectedRowIndex,
    calendar: calendar,
    columns: columns,
    setSelection: setSelection,
    componentPath: componentPath,
    wrappingInterval: wrappingInterval
  });
  var defaultSortOrder = (0, _helpers.getDefaultSortOrder)(columns);
  var defaultFilters = (0, _helpers.getDefaultFilters)(columns, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  var isMetricTypeDurationSelected = selectedMetric != null && (selectedMetric == null ? void 0 : selectedMetric.length) !== 0 && selectedMetric.every(function (metric) {
    return (metric == null ? void 0 : metric.type) === "duration";
  });
  return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
    manual: true,
    applyPagination: function applyPagination(updatedData) {
      return updatedData.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize);
    },
    showPagination: true,
    pages: Math.ceil(data.length / pagination.pageSize),
    page: pagination.page,
    pageSize: pagination.pageSize,
    onFetchData: function onFetchData(_ref) {
      var page = _ref.page,
        pageSize = _ref.pageSize;
      setPagination({
        page: page,
        pageSize: pageSize
      });
    },
    pageSizes: [25, 50, 100, 250],
    defaultSorted: defaultSortOrder.map(function (_ref2) {
      var id = _ref2.id,
        desc = _ref2.desc;
      return {
        id: id,
        desc: desc
      };
    }),
    filterable: true,
    defaultFiltered: defaultFilters,
    height: height,
    width: width,
    style: {
      height: height + "px",
      width: width + "px"
    },
    columns: formattedColumns,
    data: data,
    loading: loading,
    onRowClick: dataRange !== "SELECTION" ? onRowClick : undefined,
    selectedRowIndex: selectedRowIndex,
    resetSelectedRowIndex: resetSelectedRowIndex,
    noDataText: noDataText,
    reload: reload,
    additionalToolbarSelectors: additionalToolbarSelectors,
    showDownloadDropdownButton: isMetricTypeDurationSelected,
    getDataForCSV: isMetricTypeDurationSelected ? function (columns, data, timeFormat) {
      return (0, _formatMetricTableData.formatMetricTableData)(columns, data, timeFormat);
    } : null
  });
}